"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotion = require("emotion");

var sizes = {
  s: '2px',
  m: '4px',
  l: '6px',
  xl: '8px'
};

var ProgressBar = function ProgressBar(_ref) {
  var className = _ref.className,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 's' : _ref$size,
      type = _ref.type,
      color = _ref.color,
      value = _ref.value,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["className", "size", "type", "color", "value"]);
  var progressClasses = (0, _emotion.cx)('progress', className);
  var progressBarClasses = (0, _emotion.cx)('progress-bar', (0, _defineProperty2["default"])({}, "progress-bar-".concat(type), type));
  var style = color ? {
    width: "".concat(value, "%"),
    background: color
  } : {
    width: "".concat(value, "%")
  };
  var containerStyle = {
    height: sizes[size]
  };
  return _react["default"].createElement("div", (0, _extends2["default"])({
    className: progressClasses,
    style: containerStyle
  }, rest), _react["default"].createElement("div", {
    className: progressBarClasses,
    style: style
  }));
};

ProgressBar.propTypes = {
  size: _propTypes["default"].oneOf(['s', 'm', 'l', 'xl']),
  type: _propTypes["default"].oneOf(['success', 'warning', 'danger', 'info']),
  color: _propTypes["default"].string,
  value: function value(props, propName) {
    if (typeof props[propName] !== 'number' || props[propName] < 0 || props[propName] > 100) {
      return new Error('value must be a number between 0 and 100');
    }

    return null;
  },
  className: _propTypes["default"].string
};
var _default = ProgressBar;
exports["default"] = _default;